import { render } from "./NavbarItem.vue?vue&type=template&id=7ed595cc&scoped=true"
import script from "./NavbarItem.vue?vue&type=script&lang=js"
export * from "./NavbarItem.vue?vue&type=script&lang=js"

import "./NavbarItem.vue?vue&type=style&index=0&id=7ed595cc&lang=scss&scoped=true"
import "./NavbarItem.vue?vue&type=style&index=1&id=7ed595cc&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed595cc"]])

export default __exports__